import rutasAhorroYCredito from './routes';

const apikey = process.env.REACT_APP_MAP_KEY;

export {rutasAhorroYCredito as rutas, apikey}